import { render, staticRenderFns } from "./resultsDetails.vue?vue&type=template&id=54e4dd24&scoped=true"
import script from "./resultsDetails.vue?vue&type=script&lang=js"
export * from "./resultsDetails.vue?vue&type=script&lang=js"
import style0 from "./resultsDetails.vue?vue&type=style&index=0&id=54e4dd24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4dd24",
  null
  
)

export default component.exports